import { render, staticRenderFns } from "./CheckpointList.vue?vue&type=template&id=163e54b9"
import script from "./CheckpointList.vue?vue&type=script&lang=js"
export * from "./CheckpointList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports